import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import style from './EmotionAdd.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import { styled } from '@mui/material/styles';
import LinearProgress, {linearProgressClasses,} from '@mui/material/LinearProgress';
import URL from "../../../../../constants/url";
import SurveyMain from '../../../../../components/comsurvey/SurveyMain';
import SurveyListNormal from '../../../../../components/comsurvey/SurveyListNormal';
import SurveyComplete from '../../../../../components/comsurvey/SurveyComplete';
import ToastPopup from '../../../../../components/comm/ToastPopup';
import Modal from '../../../../../components/comm/Modal';


import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

import data_emotion from './data_emotion.json';


//상위 스텝 바 
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}));

const EmotionAdd = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [step, setStep] = useState(0);  // 0 = "설문 메인페이지"
    const [selectedValues, setSelectedValues] = useState({});
    const [toast, setToast] = useState(false);

    //전송중 체크
    const isSendingRef = useRef(false);    
    const [isLoading, setIsLoading] = useState(false);   //로딩
    const [finishOpen, setFinishOpen] = useState(false);    // 제출 모달창
    const [backConfirmOpen, setBackConfirmOpen] = useState(false);  // 뒤로가기 확인 창
    const [continueModalOpen, setContinueModalOpen] = useState(false);
    const [resultData, setResultData] = useState({});
    const survey_data = data_emotion[0];
    const outline = survey_data.outline;
    const surveyList = survey_data.surveyList;
    const totalSteps = surveyList.length;  // 설문 항목 개수

    //뒤로가기 
    const handleBackClick = () => {

        // 설문을 작성하지 않은 상태면 바로 뒤로가기
        const hasAnswer = Object.keys(selectedValues).length > 0;

        if (step === 0 || !hasAnswer) {
            navigate(-1);
            return;
        }else {
            setBackConfirmOpen(true);
        }
    };
    // 뒤로가기 클릭 시 현재까지 내용 임시저장
    const handleConfirmBack = () => {
        setBackConfirmOpen(false);
        if (Object.keys(selectedValues).length === 0) {
            navigate(-1);
            return;    // 작성된 설문이 없으면 제출 x
        };
        handleSubmit(true);
        navigate(-1);
    };
    const fetchedRef = useRef(false);

    //중복방지 조회
    useEffect(() => {
        if (fetchedRef.current) return;
        fetchedRef.current = true;
        fetchResultData();
    }, []);

    // 제출결과 조회
    const fetchResultData = async () => {
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const url = "/homecare/srvey/retrieveUsrSrveyRslt"
        const jToken = localStorage.getItem('jToken');
        const reqBody = {
                    srveyMngId: 3,  //(TODO: id값은 하드코딩. 로컬 DB에 따라 셋팅필요)
                    usrInfoId: loginUser.usrInfoId,
                    srveyBgnDe: location.state?.date,
                    srveyEndDe: location.state?.date
                };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const resultData = res.data.result.resultData;
                console.log("========> usrSrveyRsltId: ", res.data.result.resultData.usrSrveyRsltId);
                setResultData(resultData);
            } 
            else if(res.data.resultCode === CODE.RCV_FAILURE) {
                setResultData(null);
            }
            else {
                alert(res.data.resultMessage);
            }
            
        } catch (err) {
            console.error("제출기록 조회 중 오류", err);
        }
    };
    
    // 제출기록 조회
    const fetchSubmittedData = async () => {
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);

        const url = "/homecare/srvey/retrieveUsrSrveySbmtList"
        const jToken = localStorage.getItem('jToken');
        const reqBody = {
                    usrSrveyRsltId: resultData.usrSrveyRsltId
                };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            const resultList = res.data.result.resultList || [];
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                // selectedValues 초기값 구성
                const selectedMap = {};
                resultList.forEach(ans => {
                    const key = `q${ans.qesitmNo}`;
                    selectedMap[key] = {
                        value: ans.answrArry,
                        markVal: ans.markVal
                    };
                });
                setSelectedValues(selectedMap);
                const hasValidAnswer = resultList.some(ans => ans.markVal !== -1);
                if (hasValidAnswer) {
                    setContinueModalOpen(true);
                }
                else {
                    handleNext();
                }
            } else {
                alert(res.data.resultMessage);
            }
            
        } catch (err) {
            console.error("제출기록 조회 중 오류", err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    };

    const handleChange = (e, value) => {
        const currentSurvey = surveyList[step - 1];
        const name = currentSurvey.name;

        // scale
        if (currentSurvey.type === 'scale') {
            setSelectedValues(prev => ({
                ...prev,
                [name]: {
                    value: value,
                    markVal: Number(value)
                }
            }));
            return;
        }

        // single
        if (currentSurvey.type === 'single' || currentSurvey.type === 'selectImg') {
            const selectedOption = currentSurvey.options?.find(opt => opt.value === value);
            const markVal = selectedOption?.markVal ?? -1;

            setSelectedValues(prev => ({
                ...prev,
                [name]: {
                    value: value,
                    markVal: markVal
                }
            }));
            return;
        }

        // multi
        if (currentSurvey.type === 'multi') {
            const prevSelected = selectedValues[name]?.value ?? [];
            const wasChecked = prevSelected.includes(value);

            const newSelected = wasChecked
                ? prevSelected.filter(v => v !== value)
                : [...prevSelected, value];

            const newMarkVal = newSelected.reduce((acc, v) => {
                const opt = currentSurvey.options?.find(opt => opt.value === v);
                return acc + (opt?.markVal ?? 0);
            }, 0);

            setSelectedValues(prev => ({
                ...prev,
                [name]: {
                    value: newSelected,
                    markVal: newMarkVal
                }
            }));
            return;
        }
    };

    const handleNext = () => {
        if (step < totalSteps) {
            setStep(step + 1);
        } else if (step === totalSteps) {
             setFinishOpen(true); 
        }
    };

    const checkFirstRecord = () => {
        if (resultData !== null) { //금일 유효 설문지(결과)가 있을 경우
            fetchSubmittedData();
        }
        else {
            createSurveyResult();
        }
    }

    const handlePre = () => {
        setStep(step - 1);
    };


    const cancelModal = () => {
        setFinishOpen(false)
    }

    //설문 결과 생성
    const createSurveyResult = async () => {
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);

        const url = "/homecare/srvey/saveUsrSrveyRslt"
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        // 오늘 날짜
        const today = new Date();
        const todayStr = today.toISOString().slice(0, 10).replace(/-/g, ""); // ex: '20250715'


        const jToken = localStorage.getItem('jToken');
        const reqBody = {
            srveyMngId: 3,     //(TODO: id값은 하드코딩. 로컬 DB에 따라 셋팅필요)
            usrInfoId: loginUser.usrInfoId,
            lastRsltCn: "설문에 응답해주셔서 감사합니다.",
            cnncHsptlCd: "012",
            cnncDeptNm: "혈액내과",
            srveyBgnDe: location.state?.date,
            srveyEndDe: location.state?.date    // 당일 시작 당일 만료 기록 
        };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const resultData = {
                    usrSrveyRsltId: res.data.result.usrSrveyRsltId
                };
                setResultData(resultData);
                handleNext();
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("기록 제출 중 오류: ", err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    };

    //제출 내용 패키징
    const buildSubmitRequest = () => {
        console.log("resultData", resultData);
        return {
            usrSrveyRsltId: resultData?.usrSrveyRsltId,
            answrList: surveyList.map((item) => {
                const selected = selectedValues[item.name] || {};
                const value = selected.value;

                return {
                    qesitmNo: Number(item.id),
                    qesitmCn: item.question,
                    qesitmSeCd: item.type === 'single' ? '1' : item.type === 'multi' ? '2' : '3',
                    answrArry: Array.isArray(value) ? value : [value],
                    markVal: selected.markVal ?? -1  // 뒤로가기 시 미작성한 설문 선택값을 -1로 표시
                };
            })
        };
    };
    // 제출 내용 저장
    
    const handleSubmit = async (back) => {
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);

        const url = "/homecare/srvey/saveUsrSrveySbmtList"
        const jToken = localStorage.getItem('jToken');
        const reqBody = buildSubmitRequest();
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                if(back) {
                    navigate(-1); // 뒤로가기 시 제출내용만 저장 (결과 x)
                }
                else{
                    handleResultSave();
                }
                
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("기록 제출 중 오류: ", err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    };
    
    //설문 결과 저장
    const handleResultSave = async () => {
        const url = "/homecare/srvey/updateUsrSrveyRslt"
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const totalValue =
        surveyList.reduce((acc, item) => {
            const val = selectedValues[item.name]?.markVal ?? 0;
            return acc + val;
        }, 0);

        const jToken = localStorage.getItem('jToken');
        const reqBody = {
            srveyMngId: 3,     //(TODO: id값은 하드코딩. 로컬 DB에 따라 셋팅필요)
            usrInfoId: loginUser.usrInfoId,
            usrSrveyRsltId: resultData.usrSrveyRsltId,
            lastMarkVal: totalValue
        };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setFinishOpen(false);
                setToast(true);
                setTimeout(() => {
                    navigate(-1);
                }, 1200);
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("기록 제출 중 오류: ", err);
        }
    };

    
    return (
        <>
            <HeadSub title={outline.title} onBack={handleBackClick}/>
 
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    {/* Progress Bar */}
                    {step >= 1 && step <= totalSteps && (
                        <div className={style["progress-box"]}>
                            <p className={style["progress-count"]}>
                                <span>{step}</span>/<span>{totalSteps}</span>
                            </p>

                            <BorderLinearProgress
                                variant="determinate"
                                value={(step / totalSteps) * 100}
                                className={style['border-linear-progress']}
                            />
                        </div>
                    )}
                    
                    {step === 0 ? (
                        <SurveyMain data={resultData}/>
                    ) : step >= 1 && step <= totalSteps ? (
                        <SurveyListNormal
                            surveyData={surveyList[step - 1]}
                            selectedValue={
                                selectedValues[surveyList[step - 1].name]?.value
                                || (surveyList[step - 1].type === 'multi' ? [] : '')
                            }
                            onChange={handleChange}
                            step={step}
                        />
                    ) : null}

                
                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">

                            {step === 0 ? (
                                <div className="btn-layout" data-btn-num="1">
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        disabled={isLoading}
                                        onClick={checkFirstRecord}
                                    >
                                        <span>{isLoading ? "로딩 중.." : "작성 시작"}</span>
                                    </button>
                                </div>
                            ) : (
                                <div className="btn-layout" data-btn-num="2">
                                    <button
                                        className="btn"
                                        data-btn-type="outline-main"
                                        data-btn-size="lg"
                                        onClick={handlePre}
                                        disabled={step === 0}
                                    >
                                        <span>이전</span>
                                    </button>

                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={handleNext}
                                        disabled={
                                            step >= 1 &&
                                            step <= totalSteps &&
                                            (
                                                surveyList[step - 1].type === 'multi'
                                                ? !selectedValues[surveyList[step - 1].name] || selectedValues[surveyList[step - 1].name].length === 0
                                                : !selectedValues[surveyList[step - 1].name]
                                                || selectedValues[surveyList[step - 1].name].markVal === -1
                                            )
                                        }
                                    >
                                        <span>
                                            {step < totalSteps
                                                ? "다음"
                                                : step === totalSteps
                                                ? "작성 완료"
                                                : null
                                            }
                                        </span>
                                    </button>
                                </div>
                            )}
                            
                        </div>
                    </div>               
                    {/* 하단 다음 버튼 영역 :: E */} 

                    {toast && (
                        <ToastPopup
                        setToast={setToast}
                        message={'건강 기록 완료!'}
                        position="center"
                        opacity="90"
                        />
                    )}            
                </div>
            </div>


            {/* 제출 확인 모달 */}
            <Modal isOpen={finishOpen} setIsOpen={setFinishOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>작성 완료하시겠어요?</p>
                        </div>
                        {/* <div className="sub-box">
                            <span>모든 설문이 완료 되었습니다.</span>
                        </div> */}
                    </div>

                    <div className="modal-bottom-box"> 
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={cancelModal}>
                                <span>아니오</span>
                            </button>
                            <button 
                                className="btn" 
                                data-btn-type="fill-main" 
                                data-btn-size="md"
                                disabled={isLoading}
                                onClick={()=> handleSubmit(false) }
                            >
                                <span>{isLoading ? "저장 중.." : "네"}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>       


            {/* 취소 확인 모달 */}
            <Modal isOpen={backConfirmOpen} setIsOpen={setBackConfirmOpen}>
                <div className="modal-box" data-type="a">
                    <div className="modal-top-box">
                        <div className="title-box">
                            <p>작성 중이던 내용은 자동으로 <br /> 임시 저장됩니다.</p>
                        </div>
                    </div>
                    <div className="modal-bottom-box">
                        <div className="btn-layout">
                            {/* <button
                                className="btn"
                                data-btn-type="fill-gray"
                                data-btn-size="md"
                                onClick={() => setBackConfirmOpen(false)}
                            >
                                <span>아니오</span>
                            </button> */}
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                disabled={isLoading}
                                onClick={handleConfirmBack}
                            >
                                <span>{isLoading ? "저장 중.." : "확인"}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* 이어서 작성하기 확인 모달 */}
            <Modal isOpen={continueModalOpen} setIsOpen={setContinueModalOpen}>
                <div className="modal-box" data-type="a">
                    <div className="modal-top-box">
                        <div className="title-box">
                            <p>작성 중이던 내용이 있습니다.</p>
                        </div>
                    </div>
                    <div className="modal-bottom-box">
                        <div className="btn-layout">
                            <button
                                className="btn"
                                data-btn-type="fill-gray"
                                data-btn-size="md"
                                data-btn-pad='sm'
                                onClick={() => {
                                    // 새로 시작 → 기존 응답 제거
                                    setSelectedValues({});
                                    setContinueModalOpen(false);
                                    setStep(1);
                                }}
                            >
                                <span>새로 작성하기</span>
                            </button>
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                data-btn-pad='sm'
                                onClick={() => {
                                    const lastAnsweredStep = surveyList.findIndex(item => {
                                        const selected = selectedValues[item.name];
                                        return !selected || selected.markVal === -1;
                                    });
                                    const nextStep = lastAnsweredStep === -1 ? totalSteps : lastAnsweredStep + 1;
                                    setStep(nextStep); // 이어서 작성할 step으로 이동
                                    setContinueModalOpen(false);
                                }}
                            >
                                <span>이어서 작성하기</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

        </>
    );
};

export default EmotionAdd;
